import React from 'react';

function Footer() {
  return (
    <footer className="w-full bg-gray-100 py-6 text-center border-t">
      <p className="text-gray-600 text-sm mb-3">© 2025 PotatoPapers. All rights reserved.</p>
      
      {/* Legal Links Footer */}
      <div style={{ fontSize: '0.85rem', letterSpacing: '0.3px' }}>
        <a href="#/disclaimer" style={{ color: '#2563eb', textDecoration: 'none', fontWeight: 500 }}>Disclaimer</a>
        <span style={{ color: '#9ca3af', margin: '0 0.5rem' }}>|</span>
        <a href="#/privacy" style={{ color: '#2563eb', textDecoration: 'none', fontWeight: 500 }}>Privacy Policy</a>
        <span style={{ color: '#9ca3af', margin: '0 0.5rem' }}>|</span>
        <a href="#/terms" style={{ color: '#2563eb', textDecoration: 'none', fontWeight: 500 }}>Terms of Use</a>
        <span style={{ color: '#9ca3af', margin: '0 0.5rem' }}>|</span>
        <a href="#/cookies" style={{ color: '#2563eb', textDecoration: 'none', fontWeight: 500 }}>Cookies</a>
      </div>
      
      <p className="text-gray-500 text-xs mt-3">Papers sourced from external providers—self-hosting coming soon. | Video solutions may be inaccurate.</p>
    </footer>
  );
}

export default Footer;
